import { type PaginatedSelectedRows } from "@design-system/Table";

/**
 * Calculates the number of selected rows in a table based on the paginated selection.
 *
 * @param paginatedSelection - The selection object containing all_token, exclude_ids, and include_ids.
 * @param rowCount - The total number of rows in the table.
 * @returns The count of selected rows.
 */
export function getSelectedRowsCount(
    paginatedSelection: PaginatedSelectedRows,
    rowCount: number,
) {
    const { all_token, exclude_ids, include_ids } = paginatedSelection;

    const excludedRowsCount = Object.values(exclude_ids ?? {}).filter(
        Boolean,
    ).length;

    const includedRowsCount = Object.values(include_ids ?? {}).filter(
        Boolean,
    ).length;

    const selectedRowsCountWithAllToken = rowCount - excludedRowsCount;
    const selectedRowsCountWithoutAllToken = includedRowsCount;

    const selectedRowsCount = all_token
        ? selectedRowsCountWithAllToken
        : selectedRowsCountWithoutAllToken;

    return selectedRowsCount;
}

/**
 * Retrieves the list of selected item IDs based on the paginated selection of a table.
 *
 * @param paginatedSelection - The selection object containing all_token, exclude_ids, and include_ids.
 * @param itemIds - The array of all item IDs not paginated.
 * @returns An array of selected item IDs.
 */
export function getSelectedIds(
    paginatedSelection: PaginatedSelectedRows,
    itemIds: string[],
) {
    const { all_token, exclude_ids, include_ids } = paginatedSelection;

    if (all_token) {
        return itemIds.filter((id) => !exclude_ids[id]);
    }

    return itemIds.filter((id) => include_ids[id]);
}
